export default __webpack_public_path__ + "static/media/payment-success.c9f87277.png";